/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */

// 资金管理
import CapitalIndex from './capital/Index';
import CapitalDetail from './capital/detail/Index';

import FundsIndex from './funds/Index';
import FundsDetail from './funds/detail/Index';

// 资金统计
import StatisticsIndex from './statistics/Index';
import PageYear from './statistics/PageYear';

// 资金运营统计
import operationalIndex from './operational/Index';
import operationalYear from './operational/PageYear';
// 预算管理
import BudgetIndex from './budget/Index';
import BudgetCheck from './budget/check/Index';
import CheckPayDetail from './budget/check/PagePayDetail';
import BudgetMonth from './budget/detail/Index';
import BudgetMonthDetail from './budget/detail/PageDetail';
import BudgetToView from './budget/toview';
// 预算设置
import BudgetSetWatch from './budget/set/PageWatch';
import BudgetSetMine from './budget/set/PageMine';
import BudgetSetInfo from './budget/set/PageInfo';

// 预算调整
import BudgetAdjust from './budget/adjust/PageAdd';
import BudgetAdjustInfo from './budget/adjust/PageInfo';
import BudgetAdjustWatch from './budget/adjust/PageWatch';
import BudgetAdjustMine from './budget/adjust/PageMine';
import BudgetOrg from './budget/org/Index';
// 收支分析
import BudgetBalance from './budget/balance';
import BalanceIncome from './budget/balance/income/Index';
import BalanceExpend from './budget/balance/expend/Index';
import BalanceTrace from './budget/balance/profit/Index';
// 预算统计
import BudgetsIndex from './budgets/Index';
import BudgetsYear from './budgets/PageYear';
// 财务分析
import AnalyzeIndex from './analyze/Index';
// 划款申请
import PlatformTransferAdd from './platformTransfer/PageAdd';
import PlatformTransferOpen from './platformTransfer/PageInfo';
import PlatformTransferMine from './platformTransfer/PageMine';
import PlatformTransferWatch from './platformTransfer/PageWatch';
// 报销申请
import ExpensesMine from './expenses/PageMine';
import ExpensesAdd from './expenses/PageAdd';
import ExpensesWatch from './expenses/PageWatch';
import ExpensesCompany from './expenses/PageCompany';
import ExpensesIncubator from './expenses/PageIncubator';
import ExpensesOpen from './expenses/PageInfo';
// 付款申请
import PaymentAdd from './payment/PageAdd';
import PaymentOpen from './payment/PageInfo';
import PaymentWatch from './payment/PageWatch';
import PaymentMine from './payment/PageMine';
import PaymentCompany from './payment/PageCompany';
import PaymentIncubator from './payment/PageIncubator';
// 借款申请
import LoanMine from './loan/PageMine';
import LoanAdd from './loan/PageAdd';
import LoanWatch from './loan/PageWatch';
import LoanCompany from './loan/PageCompany';
import LoanIncubator from './loan/PageIncubator';
import LoanOpen from './loan/PageInfo';
// 开票申请
import InvoiceAdd from './invoice/PageAdd';
import InvoiceCompany from './invoice/PageCompany';
import InvoiceIncubator from './invoice/PageIncubator';
import InvoiceMine from './invoice/PageMine';
import InvoiceWatch from './invoice/PageWatch';
import InvoiceOpen from './invoice/PageInfo';
// 分摊管理
import ApportionIndex from './apportion/Index';
import ApportionAdd from './apportion/PageAdd';
import ApportionEdit from './apportion/PageEdit';
import ApportionRecord from './apportion/PageRecord';

// 公司账户信息
import BookInfoIndex from './bookInfo/Index';
import BookInfoAdd from './bookInfo/PageAdd';
import BookInfoEdit from './bookInfo/PageEdit';
import BookInfoOpen from './bookInfo/PageOpen';

// 公司回单卡记录
import ReceiptIndex from './receipt/Index';
import ReceiptAdd from './receipt/PageAdd';
import ReceiptEdit from './receipt/PageEdit';
import ReceiptOpen from './receipt/PageOpen';

const router = {
  path: 'finance',
  breadcrumbName: '财务',
  childRoutes: [
    {
      path: 'capital',
      breadcrumbName: '资金管理',
      indexRoute: { component: CapitalIndex },
      childRoutes: [
        {
          path: ':uuid/detail',
          component: CapitalDetail,
          breadcrumbName: '资金流水',
        },
      ],
    },
    {
      path: 'funds',
      breadcrumbName: '资金帐号管理',
      indexRoute: { component: FundsIndex },
      childRoutes: [
        {
          path: ':uuid/detail',
          component: FundsDetail,
          breadcrumbName: '资金帐号流水',
        },
      ],
    },
    {
      path: 'budget',
      breadcrumbName: '预算管理',
      indexRoute: { component: BudgetIndex },
      childRoutes: [
        {
          path: ':uuid/check',
          breadcrumbName: '预算流水',
          indexRoute: { component: BudgetCheck },
          childRoutes: [
            {
              path: ':checkUuid/payDetail',
              component: CheckPayDetail,
              breadcrumbName: '付款明细',
            },
          ],
        },
        {
          path: ':uuid/month',
          breadcrumbName: '月度预算',
          indexRoute: { component: BudgetMonth },
          childRoutes: [
            {
              path: ':monthUuid/detail',
              component: BudgetMonthDetail,
              breadcrumbName: '付款明细',
            },
          ],
        },
        {
          path: ':uuid/toviewDetail',
          breadcrumbName: '查看预算',
          indexRoute: { component: BudgetToView },
        },
        {
          path: 'set_manage_watch',
          breadcrumbName: '预算设置监控',
          indexRoute: { component: BudgetSetWatch },
        },
        {
          path: 'set_manage_mine',
          breadcrumbName: '我的预算设置申请',
          indexRoute: { component: BudgetSetMine },
        },
        {
          path: ':uuid/set_manage/detail',
          breadcrumbName: '预算设置审核',
          indexRoute: { component: BudgetSetInfo },
        },
        {
          path: 'adjust_manage_watch',
          breadcrumbName: '预算调整监控',
          indexRoute: { component: BudgetAdjustWatch },
        },
        {
          path: 'adjust_manage_mine',
          breadcrumbName: '我的预算调整申请',
          indexRoute: { component: BudgetAdjustMine },
        },

        {
          path: ':uuid/:year/adjust',
          breadcrumbName: '预算调整',
          indexRoute: { component: BudgetAdjust },
        },
        {
          path: ':uuid/:year/adjust/info',
          breadcrumbName: '预算调整审核',
          indexRoute: { component: BudgetAdjustInfo },
        },
        {
          path: ':uuid/:year/balance',
          breadcrumbName: '收支分析',
          indexRoute: { component: BudgetBalance },
        },
        {
          path: ':uuid/balance/income',
          component: BalanceIncome,
          breadcrumbName: '收入',
        },
        {
          path: ':uuid/balance/expense',
          component: BalanceExpend,
          breadcrumbName: '支出',
        },
        {
          path: ':uuid/balance/trace',
          component: BalanceTrace,
          breadcrumbName: '利润追踪',
        },
        {
          path: 'org',
          breadcrumbName: '部门预算管理',
          indexRoute: { component: BudgetOrg },
        },
      ],
    },
    {
      path: 'budgets',
      breadcrumbName: '预算统计',
      indexRoute: { component: BudgetsIndex },
      childRoutes: [
        {
          path: ':uuid/year',
          component: BudgetsYear,
          breadcrumbName: '预算按年统计',
        },
      ],
    },
    {
      path: 'operational',
      breadcrumbName: '资金运营统计',
      indexRoute: { component: operationalIndex },
      childRoutes: [
        {
          path: ':uuid/buddget',
          component: BudgetCheck,
          breadcrumbName: '预算按年统计',
        },
        {
          path: ':uuid/year',
          component: operationalYear,
          breadcrumbName: '预算按年统计',
        },
      ],
    },
    {
      path: 'statis',
      breadcrumbName: '资金统计',
      indexRoute: { component: StatisticsIndex },
      childRoutes: [
        {
          path: ':uuid/detail',
          component: CapitalDetail,
          breadcrumbName: '资金统计详情',
        },
        {
          path: ':uuid/year',
          component: PageYear,
          breadcrumbName: '资金按年统计',
        },
        {
          path: 'ignore',
          component: CapitalDetail,
          breadcrumbName: '走账数据列表',
        },
      ],
    },
    {
      path: 'analyze',
      breadcrumbName: '财务分析',
      indexRoute: { component: AnalyzeIndex },
    },

    // 平台划款
    {
      path: 'pt_manage',
      indexRoute: {
        component: PlatformTransferMine,
      },
      breadcrumbName: '平台划款管理',
      childRoutes: [
        {
          path: 'add',
          component: PlatformTransferAdd,
          breadcrumbName: '平台划款申请',
        },
        {
          path: 'open/:uuid',
          component: PlatformTransferOpen,
          breadcrumbName: '查看平台划款',
        },
      ],
    },
    {
      path: 'pt_manage_watch',
      component: PlatformTransferWatch,
      breadcrumbName: '平台划款监控',
    },
    {
      path: 'pt_manage_mine',
      component: PlatformTransferMine,
      breadcrumbName: '我的平台划款',
    },
    {
      path: 'e_manage',
      indexRoute: {
        component: ExpensesMine,
      },
      breadcrumbName: '报销管理',
      childRoutes: [
        {
          path: 'add',
          component: ExpensesAdd,
          breadcrumbName: '报销申请',
        },
        {
          path: 'open/:uuid',
          component: ExpensesOpen,
          breadcrumbName: '查看报销',
        },
      ],
    },

    {
      path: 'e_manage_watch',
      component: ExpensesWatch,
      breadcrumbName: '报销监控',
    },
    {
      path: 'e_manage_mine',
      component: ExpensesMine,
      breadcrumbName: '我的报销',
    },
    {
      path: 'e_manage_company',
      component: ExpensesCompany,
      breadcrumbName: '按公司统计',
    },
    {
      path: 'e_manage_incubator',
      component: ExpensesIncubator,
      breadcrumbName: '按孵化器统计',
    },
    {
      path: 'p_manage',
      indexRoute: {
        component: PaymentMine,
      },
      breadcrumbName: '付款管理',
      childRoutes: [
        {
          path: 'add',
          component: PaymentAdd,
          breadcrumbName: '报销申请',
        },
        {
          path: 'open/:uuid',
          component: PaymentOpen,
          breadcrumbName: '查看付款',
        },
      ],
    },
    {
      path: 'p_manage_mine',
      component: PaymentMine,
      breadcrumbName: '我的付款',
    },
    {
      path: 'p_manage_company',
      component: PaymentCompany,
      breadcrumbName: '按公司统计',
    },
    {
      path: 'p_manage_incubator',
      component: PaymentIncubator,
      breadcrumbName: '按孵化器统计',
    },
    {
      path: 'p_manage_watch',
      component: PaymentWatch,
      breadcrumbName: '付款监控',
    },
    // 借款
    {
      path: 'l_manage',
      indexRoute: {
        component: LoanMine,
      },
      breadcrumbName: '借款管理',
      childRoutes: [
        {
          path: 'add',
          component: LoanAdd,
          breadcrumbName: '借款申请',
        },
        {
          path: 'open/:uuid',
          component: LoanOpen,
          breadcrumbName: '查看借款',
        },
      ],
    },
    {
      path: 'l_manage_mine',
      component: LoanMine,
      breadcrumbName: '我的借款',
    },
    {
      path: 'l_manage_company',
      component: LoanCompany,
      breadcrumbName: '按公司统计',
    },
    {
      path: 'l_manage_incubator',
      component: LoanIncubator,
      breadcrumbName: '按孵化器统计',
    },
    {
      path: 'l_manage_watch',
      component: LoanWatch,
      breadcrumbName: '借款监控',
    },
    // 开票
    {
      path: 'i_manage',
      indexRoute: {
        component: InvoiceMine,
      },
      breadcrumbName: '开票管理',
      childRoutes: [
        {
          path: 'add',
          component: InvoiceAdd,
          breadcrumbName: '开票申请',
        },
        {
          path: 'open/:uuid',
          component: InvoiceOpen,
          breadcrumbName: '查看开票',
        },
      ],
    },
    {
      path: 'i_manage_watch',
      component: InvoiceWatch,
      breadcrumbName: '开票监控',
    },
    {
      path: 'i_manage_mine',
      component: InvoiceMine,
      breadcrumbName: '我的开票',
    },
    {
      path: 'i_manage_company',
      component: InvoiceCompany,
      breadcrumbName: '按公司统计',
    },
    {
      path: 'i_manage_incubator',
      component: InvoiceIncubator,
      breadcrumbName: '按孵化器统计',
    },
    {
      path: 'apportion',
      indexRoute: {
        component: ApportionIndex,
      },
      breadcrumbName: '分摊管理',
      childRoutes: [
        {
          path: 'add',
          component: ApportionAdd,
          breadcrumbName: '新增分摊',
        },
        {
          path: 'open/:uuid',
          component: ApportionEdit,
          breadcrumbName: '查看分摊',
        },
        {
          path: 'record/:uuid',
          component: ApportionRecord,
          breadcrumbName: '分摊记录',
        },
      ],
    },
    {
      path: 'bookInfo',
      indexRoute: {
        component: BookInfoIndex,
      },
      breadcrumbName: '公司账户信息',
      childRoutes: [
        {
          path: 'add',
          component: BookInfoAdd,
          breadcrumbName: '新增公司账户信息',
        },
        {
          path: 'edit/:uuid',
          component: BookInfoEdit,
          breadcrumbName: '编辑公司账户信息',
        },
        {
          path: 'open/:uuid',
          component: BookInfoOpen,
          breadcrumbName: '查看公司账户信息',
        },
      ],
    },
    {
      path: 'receipt',
      indexRoute: {
        component: ReceiptIndex,
      },
      breadcrumbName: '公司回单卡记录',
      childRoutes: [
        {
          path: 'add',
          component: ReceiptAdd,
          breadcrumbName: '新增公司回单卡记录',
        },
        {
          path: 'edit/:uuid',
          component: ReceiptEdit,
          breadcrumbName: '编辑公司回单卡记录',
        },
        {
          path: 'open/:uuid',
          component: ReceiptOpen,
          breadcrumbName: '查看公司回单卡记录',
        },
      ],
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/finance/router.js